import React, { useState } from 'react';
import { Heart, CheckCircle2 } from 'lucide-react';

export const AnimalTherapyModule: React.FC = () => {
  const [selectedAnimal, setSelectedAnimal] = useState('Barnaby (Certified Goldendoodle)');
  const [anxietyScore, setAnxietyScore] = useState(3);
  const [loggedMsg, setLoggedMsg] = useState('');

  const handleLogSession = () => {
    setLoggedMsg(`Therapy session with ${selectedAnimal} logged! Stress score reduced to ${anxietyScore}/10.`);
    setTimeout(() => setLoggedMsg(''), 4000);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-rose-100 text-rose-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Animal-Assisted Therapy (AAT)
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Animal-Assisted Therapy & Pet Care</h2>
          <p className="text-xs text-slate-500">Therapy animal visit scheduling, anxiety reduction scorecards, and pet care tasks</p>
        </div>

        <button 
          onClick={handleLogSession}
          className="px-4 py-2 bg-rose-600 hover:bg-rose-700 text-white font-bold text-xs rounded-xl shadow transition flex items-center gap-1.5"
        >
          <Heart className="w-4 h-4 text-white" />
          <span>Log AAT Session</span>
        </button>
      </div>

      {loggedMsg && (
        <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-xl text-xs font-bold flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          {loggedMsg}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-2">
          <label className="block text-xs font-bold text-slate-700">Select Certified Therapy Animal</label>
          <select 
            value={selectedAnimal}
            onChange={(e) => setSelectedAnimal(e.target.value)}
            className="w-full px-3 py-2 border rounded-xl text-xs font-bold bg-white focus:ring-2 focus:ring-rose-500"
          >
            <option value="Barnaby (Certified Goldendoodle)">Barnaby (Certified Goldendoodle)</option>
            <option value="Bella (Miniature Therapy Horse)">Bella (Miniature Therapy Horse)</option>
            <option value="Oliver (Therapy Rabbit)">Oliver (Therapy Rabbit)</option>
          </select>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-xs font-bold text-slate-700">Post-Session Anxiety Rating</span>
            <span className="text-sm font-black text-rose-600 font-mono">{anxietyScore} / 10 (Low Anxiety)</span>
          </div>
          <input 
            type="range" min="1" max="10" value={anxietyScore}
            onChange={(e) => setAnxietyScore(parseInt(e.target.value))}
            className="w-full accent-rose-600"
          />
        </div>
      </div>
    </div>
  );
};
